<div [ngClass]="{'layout-inline-menu': true, 'layout-inline-menu-active':appMain.activeInlineProfile}" *ngIf="!appMain.isMobile() && (appMain.isStatic() || appMain.isSlim() || appMain.isSidebar())">
    <a class="layout-inline-menu-action" (click)="appMain.activeInlineProfile = !appMain.activeInlineProfile">
        <!-- <img src="assets/layout/images/profile-image.png" alt="avatar" style="width: 44px; height: 44px;"> -->
        <p-avatar [label]="avatarLabel" shape="circle" severity="danger" [style]="{'background-color': '#873EFE'}"></p-avatar>
        <span class="layout-inline-menu-text">{{user?.firstName}} {{user?.lastName}}</span>
        <i class="layout-inline-menu-icon pi pi-angle-down"></i>
    </a>
    <ul class="layout-inline-menu-action-panel" [@inline]="appMain.activeInlineProfile ? 'visibleAnimated' : 'hiddenAnimated'">
        <li class="layout-inline-menu-action-item">
            <a [routerLink]="['/settings/manage/projects']">
                <i class="fi fi-tr-diagram-project"></i>
                <span >Projects</span>
            </a>
        </li>
        <li class="layout-inline-menu-action-item">
            <a [routerLink]="['/settings/profile']">
                <i class="pi pi-user pi-fw"></i>
                <span >Profile</span>
            </a>
        </li>
        <li class="layout-inline-menu-action-item">
            <a [routerLink]="['/billing/subscription']">
                <i class="fi fi-tr-money-check"></i>
                <span >Change Plan</span>
            </a>
        </li>
        <!-- <li class="layout-inline-menu-action-item">
            <a [routerLink]="['/settings/organization']">
                <i class="pi pi-cog pi-fw"></i>
                <span >Organization</span>
            </a>
        </li> -->
        <li class="layout-inline-menu-action-item">
            <a (click)="onLogoutClicked()">
                <i class="pi pi-power-off pi-fw"></i>
                <span>Logout</span>
            </a>
        </li>
    </ul>
</div>
